import { useDispatch } from 'react-redux';
import type { StaticRootState } from '@/reducers';
import type { Action } from 'redux';
import type { ThunkDispatch } from 'redux-thunk';

export type AppThunkDispatch<TStateExtension> = ThunkDispatch<StaticRootState & TStateExtension, void, Action>;

export const useAppDispatch = <TStateExtension = Record<string, never>>(): AppThunkDispatch<TStateExtension> =>
  useDispatch();
